/* eslint-disable */
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { useRef } from 'react';
import PropTypes from 'prop-types';

const FARO_COLLECTOR_URL =
  'https://faro-collector-prod-us-west-0.grafana.net/collect/2de4a97b2cc13c642b2611ac6442d4e6';

export default function FrontendObservability({ faroEnvironment, faroSamplingRate }) {
  const faroInitialized = useRef(false);

  if (typeof window !== 'undefined' && !faroInitialized.current) {
    try {
      initializeFaro({
        url: FARO_COLLECTOR_URL,
        app: {
          name: 'office-app',
          version: '1.0.0',
          environment: faroEnvironment,
        },
        instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()],
        ignoreErrors: [
          /^ResizeObserver loop limit exceeded$/,
          /^ResizeObserver loop completed with undelivered notifications$/,
          /^Script error\.$/,
          /chrome-extension:\/\//,
          /moz-extension:\/\//,
        ],
        ignoreUrls: [
          /cdn\.segment\.com/,
          /api\.segment\.io/,
          /googletagmanager\.com/,
          /analytics\.google\.com/,
          /www\.google-analytics\.com/,
          /pg\.angi\.com/,
        ],
        sessionTracking: {
          samplingRate: parseFloat(faroSamplingRate || '0.5'),
        },
      });
      faroInitialized.current = true;
    } catch (e) {}
  }

  return null;
}

FrontendObservability.propTypes = {
  faroEnvironment: PropTypes.string,
  faroSamplingRate: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/app/browser/monitoring/FrontendObservability.js